import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import type { NodeProps } from "@xyflow/react";
import { formatNZD } from "../../utils/formatters";
import { getNodeColorScheme } from "./graphUtils";
import type { CalculationNodeData } from "./graphUtils";
import styles from "./CalculationNode.module.css";

type CalculationNodeProps = NodeProps & { data: CalculationNodeData };

export const CalculationNode = memo(function CalculationNode({
  data,
}: CalculationNodeProps) {
  const colorScheme = getNodeColorScheme(data.nodeClass, data.nodeType, data.label);

  const classNames = [styles.node];
  if (data.hasVariance) classNames.push(styles.variance);
  if (data.isSelected) classNames.push(styles.selected);
  if (data.isHighlighted) classNames.push(styles.highlighted);

  return (
    <div
      className={classNames.join(" ")}
      style={{
        backgroundColor: colorScheme.background,
        borderColor: data.hasVariance ? undefined : colorScheme.border,
        color: colorScheme.text,
      }}
    >
      <Handle type="target" position={Position.Top} className={styles.handle} />
      <div className={styles.label}>{data.label}</div>
      <div className={styles.amount}>{formatNZD(data.calculatedAmount)}</div>
      {data.hasVariance && data.varianceAmount !== null && (
        <div className={styles.varianceAmount}>
          {formatNZD(data.varianceAmount)} variance
        </div>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        className={styles.handle}
      />
    </div>
  );
});
